module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin20-5abd93fd4e0b0b10076f925fc141c003.jpg";